import { type ITooltipProps, Typography, TooltipLink } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'

export const getMemberGracePeriodTooltipProps = (): ITooltipProps => ({
  type: 'description',
  label: (
    <Typography
      variant='body-md-regular'
      color='var(--content-primary-primary-inverted)'
      ariaLabel='MemberGracePeriod'
    >
      Take care of unpaid licenses
      <br /> before adding new members
    </Typography>
  ),
  width: 233,
  placement: 'top',
  breakWord: true,
  desc: (
    <TooltipLink
      text='Manage numbers'
      onClick={() => {
        uiStore.changeRoute({
          path: '/settings/organization/numbers',
        })
      }}
    />
  ),
})
